module.exports = __webpack_public_path__ + "static/media/Muli-SemiBold.63c3a87c.ttf";